import React, { useState } from 'react';
import Modal from './Modal';
import './ConfirmEntryModal.css';

const RequestPaymentModal = ({ onClose, onConfirm, customer_name }) => {
  const [amount, setAmount] = useState('500');
  const [expiryMinutes, setExpiryMinutes] = useState('60');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0) {
      setError('Please enter a valid amount.');
      return;
    }
    if (!expiryMinutes || parseInt(expiryMinutes, 10) <= 0) {
      setError('Please enter valid expiry minutes.');
      return;
    }

    setIsSubmitting(true);
    setError('');
    try {
      await onConfirm({ amount: parseFloat(amount), expiry_minutes: parseInt(expiryMinutes, 10) });
    } catch (err) {
      setError(err.message || 'Failed to send payment request.');
      setIsSubmitting(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className="confirm-delete-modal" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <h2 className="h1style" style={{ marginBottom: '15px' }}>Request Payment</h2>
        <p className="h2style" style={{ marginBottom: '15px' }}>
          Send reservation payment request to <strong>{customer_name}</strong>
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
              Amount (₹) <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="number"
              step="any"
              min="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="e.g. 500.00"
              className="reason-input"
              required
            />
          </div>

          <div className="form-group" style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
              Payment Link Expiry (Minutes) <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="number"
              min="1"
              value={expiryMinutes}
              onChange={(e) => setExpiryMinutes(e.target.value)}
              placeholder="e.g. 60"
              className="reason-input"
              required
            />
          </div>

          {error && (
            <p style={{ color: 'red', fontSize: '0.85rem', marginBottom: '10px', textAlign: 'left' }}>
              {error}
            </p>
          )}

          <div className="actions" style={{ marginTop: '20px' }}>
            <button type="button" className="cancel-button" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
            <button type="submit" className="confirm-button" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Request'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default RequestPaymentModal;
